var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [].concat(_vm.classList), style: _vm.styles }, [
    _c(
      "div",
      { staticClass: "input__inner" },
      [
        _vm.iconName
          ? _c("v-icon", {
              staticClass: "input__icon",
              attrs: { name: _vm.iconName }
            })
          : _vm._e(),
        _vm._v(" "),
        (_vm.forcedType ? _vm.forcedType : _vm.type ? _vm.type : "text") ===
        "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.requiredEmailChange
                    ? _vm.originalValue
                    : _vm.value,
                  expression: "requiredEmailChange ? originalValue : value"
                }
              ],
              ref: "inputField",
              staticClass: "input__item",
              attrs: {
                id: _vm.fieldName,
                accept: _vm.accept,
                autocomplete: _vm.autocomplete,
                disabled: _vm.disabled,
                placeholder: _vm.placeholder,
                required: _vm.validation
                  ? _vm.validation.indexOf("required") > -1
                  : false,
                tabIndex: _vm.tabIndex || -1,
                type: "checkbox"
              },
              domProps: {
                checked: Array.isArray(
                  _vm.requiredEmailChange ? _vm.originalValue : _vm.value
                )
                  ? _vm._i(
                      _vm.requiredEmailChange ? _vm.originalValue : _vm.value,
                      null
                    ) > -1
                  : _vm.requiredEmailChange
                  ? _vm.originalValue
                  : _vm.value
              },
              on: {
                blur: _vm.handleFocusOut,
                change: [
                  function($event) {
                    var $$a = _vm.requiredEmailChange
                        ? _vm.originalValue
                        : _vm.value,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.requiredEmailChange
                            ? _vm.originalValue
                            : (_vm.value = $$a.concat([$$v])))
                      } else {
                        $$i > -1 &&
                          (_vm.requiredEmailChange
                            ? _vm.originalValue
                            : (_vm.value = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1))))
                      }
                    } else {
                      _vm.requiredEmailChange
                        ? _vm.originalValue
                        : (_vm.value = $$c)
                    }
                  },
                  _vm.handleChange
                ],
                focus: _vm.handleFocusIn,
                input: _vm.handleChange,
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return (function() {
                    return _vm.onEnter()
                  })($event)
                }
              }
            })
          : (_vm.forcedType ? _vm.forcedType : _vm.type ? _vm.type : "text") ===
            "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.requiredEmailChange
                    ? _vm.originalValue
                    : _vm.value,
                  expression: "requiredEmailChange ? originalValue : value"
                }
              ],
              ref: "inputField",
              staticClass: "input__item",
              attrs: {
                id: _vm.fieldName,
                accept: _vm.accept,
                autocomplete: _vm.autocomplete,
                disabled: _vm.disabled,
                placeholder: _vm.placeholder,
                required: _vm.validation
                  ? _vm.validation.indexOf("required") > -1
                  : false,
                tabIndex: _vm.tabIndex || -1,
                type: "radio"
              },
              domProps: {
                checked: _vm._q(
                  _vm.requiredEmailChange ? _vm.originalValue : _vm.value,
                  null
                )
              },
              on: {
                blur: _vm.handleFocusOut,
                change: [
                  function($event) {
                    _vm.requiredEmailChange
                      ? _vm.originalValue
                      : (_vm.value = null)
                  },
                  _vm.handleChange
                ],
                focus: _vm.handleFocusIn,
                input: _vm.handleChange,
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return (function() {
                    return _vm.onEnter()
                  })($event)
                }
              }
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.requiredEmailChange
                    ? _vm.originalValue
                    : _vm.value,
                  expression: "requiredEmailChange ? originalValue : value"
                }
              ],
              ref: "inputField",
              staticClass: "input__item",
              attrs: {
                id: _vm.fieldName,
                accept: _vm.accept,
                autocomplete: _vm.autocomplete,
                disabled: _vm.disabled,
                placeholder: _vm.placeholder,
                required: _vm.validation
                  ? _vm.validation.indexOf("required") > -1
                  : false,
                tabIndex: _vm.tabIndex || -1,
                type: _vm.forcedType
                  ? _vm.forcedType
                  : _vm.type
                  ? _vm.type
                  : "text"
              },
              domProps: {
                value: _vm.requiredEmailChange ? _vm.originalValue : _vm.value
              },
              on: {
                blur: _vm.handleFocusOut,
                change: _vm.handleChange,
                focus: _vm.handleFocusIn,
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.requiredEmailChange
                      ? _vm.originalValue
                      : (_vm.value = $event.target.value)
                  },
                  _vm.handleChange
                ],
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return (function() {
                    return _vm.onEnter()
                  })($event)
                }
              }
            }),
        _vm._v(" "),
        _vm.variant !== "custom" && _vm.label
          ? _c("v-typo", {
              attrs: {
                classes: [
                  "input__label",
                  _vm.disabled ? "input__label--disabled" : null
                ],
                for: _vm.fieldName,
                element: "label",
                variant: "body-perex"
              },
              domProps: { innerHTML: _vm._s(_vm.label) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.suffix
          ? _c("v-typo", {
              attrs: { classes: ["input__suffix"], variant: "body-paragraph" },
              domProps: { innerHTML: _vm._s(_vm.suffix) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm._t("external")
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "errorMessage",
        staticClass: "input__error",
        class: _vm.requiredEmailChange ? "input__error--slim" : null
      },
      [
        _c(
          "transition",
          {
            attrs: { name: "roll" },
            on: {
              enter: _vm.errorAnimationEnter,
              leave: _vm.errorAnimationLeave,
              "after-enter": _vm.errorAnimationAfterEnter
            }
          },
          [
            _vm.requiredEmailChange || _vm.errorMessage[0]
              ? _c(
                  "div",
                  { ref: "errorPerex", staticClass: "input__error-container" },
                  [
                    _c("v-typo", { attrs: { variant: "body-paragraph" } }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.requiredEmailChange
                              ? _vm.$t("common.accountRequireEmailCheck", {
                                  email: _vm.requiredEmailValue
                                })
                              : _vm.errorMessage[0]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm.requiredEmailChange
                        ? _c(
                            "span",
                            {
                              staticClass: "input__error-link",
                              on: {
                                click: function() {
                                  return _vm.onEnter()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("common.resend")) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }